import moment from 'moment';

export const HOUR_HEIGHT = 56;
export const HOURS = Array.from({ length: 24 }, (_, i) => i);

export const getTzLabel = () => {
  const offset = moment().utcOffset();
  const h = Math.floor(Math.abs(offset) / 60);
  const m = Math.abs(offset) % 60;
  const sign = offset >= 0 ? '+' : '-';
  return `GMT${sign}${h}${m ? `:${String(m).padStart(2, '0')}` : ''}`;
};

export const getNowMinutes = () => {
  const n = moment();
  return n.hours() * 60 + n.minutes();
};

export const isCalendarAuthError = (message: string) =>
  message.includes('invalid_grant') ||
  message.includes('access token') ||
  message.includes('Invalid email or User ID') ||
  message.includes('notACalendarUser') ||
  message.includes('signed up for Google Calendar');
